export default "__VITE_ASSET__CRyHEq1b__"